<div [class.is-mobile]="mobileQuery.matches" class="navbar-container">
  <!-- Top navbar -->
  <mat-toolbar class="navbar" color="primary">

    <button (click)="snav.toggle()" mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button>

    <a [routerLink]="['/']" class="navbar-brand" matTooltip="Home">
      <img src="./../../../assets/img/road-aware-brand-logo.png" width="85" , height="60" />
    </a>

    <span class="navbar-spacer"></span>

    <button [matMenuTriggerFor]="userMenu" mat-button>
      <mat-icon>person</mat-icon>
      <span fxHide.xs fxShow
            [matTooltip]="'Roles: ' + (roles?.join(',') || '')">
        {{ name }}
      </span>
    </button>

    <mat-menu #userMenu="matMenu" xPosition="before" yPosition="above">
      <a (click)="signout()" mat-menu-item>
        <mat-icon>exit_to_app</mat-icon>
        <span>Log out</span>
      </a>
    </mat-menu>
  </mat-toolbar>

  <mat-sidenav-container class="navbar-sidenav-container">
    <!-- Side nav -->
    <mat-sidenav #snav [fixedInViewport]="mobileQuery.matches" [mode]="mobileQuery.matches ? 'over' : 'side'"
                 [opened]="!mobileQuery.matches" class="sidenav" fixedTopGap="56">
      <app-nav-menu></app-nav-menu>
    </mat-sidenav>

    <!-- Main content -->
    <mat-sidenav-content class="sidenav-content">

      <div class="progress-bar-container">
        <mat-progress-bar *ngIf="false" color="accent" mode="indeterminate"></mat-progress-bar>
        <!-- <mat-spinner class="spinner" [diameter]="50" *ngIf="showSpinner"></mat-spinner> -->
      </div>

      <div class="container">
        <router-outlet></router-outlet>
      </div>

    </mat-sidenav-content>
  </mat-sidenav-container>

</div>


